import React, { FC, memo } from "react";
import { useTranslation } from "react-i18next";

import { Button } from "@/components/Button";
import { Flex } from "@/eworkitComponents";

import { IFormProps } from "./types";

interface IButtonProps extends IFormProps<any> {
  onClose: () => void;
}

export const Buttons: FC<IButtonProps> = memo(({ form, onClose }) => {
  const { t } = useTranslation("session");
  return (
    <Flex direction="column" margin={["md", false, false]}>
      <Flex innerMargin="md" justify="flex-end">
        <Button variant="secondary" size="lg" testName="cancel" onClick={onClose}>
          {t("CONSULTANT_PROFILES.COMPLETENESS.BUTTON_CANCEL")}
        </Button>
        <Button size="lg" testName="save" onClick={form.submitForm} disabled={form.isSubmitting}>
          {t("CONSULTANT_PROFILES.COMPLETENESS.BUTTON_SAVE")}
        </Button>
      </Flex>
    </Flex>
  );
});
